"use client";

import { useEffect, useState } from "react";
import { CalendarDays, Mail, MapPin, MessageCircle } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ContactForm } from "@/components/contact-form";
import { SocialButtons } from "@/components/social-buttons";
import { defaultSiteSettings, type SiteSettings } from "@/lib/site-settings";

export function ContactSection() {
  const [siteSettings, setSiteSettings] = useState<SiteSettings>(defaultSiteSettings());

  useEffect(() => {
    void fetch("/api/site-settings", { cache: "no-store" })
      .then((response) => response.ok ? response.json() : null)
      .then((data) => { if (data?.settings) setSiteSettings(data.settings); })
      .catch(() => undefined);
  }, []);

  return (
    <section className="section contact-section">
      <div className="container">
        <div className="contact-heading">
          <p className="section-label">Contact</p>
          <h2>Une question avant de réserver ?</h2>
          <p>Expliquez-nous votre projet, la prestation envisagée et vos disponibilités. Nous vous répondrons dès que possible.</p>
        </div>
        <div className="contact-layout">
          <Card className="contact-card">
            <CardHeader><CardTitle>Envoyer un message</CardTitle><CardDescription>Nous revenons vers vous dès que possible.</CardDescription></CardHeader>
            <CardContent><ContactForm /></CardContent>
          </Card>
          <div className="contact-aside">
            <a className="contact-map-card" href={siteSettings.locationUrl} target="_blank" rel="noreferrer">
              <span className="contact-map-pin"><MapPin /></span>
              <span><strong>{siteSettings.city}</strong><small>Ouvrir la zone de prestation</small></span>
            </a>
            <div className="contact-details">
              <article><MapPin /><div><strong>Zone de prestation</strong><span>Nous intervenons à {siteSettings.city} et dans les environs. L’adresse exacte est communiquée après confirmation.</span></div></article>
              <article><Mail /><div><strong>Réponse par e-mail</strong><span>Utilisez le formulaire pour nous transmettre votre demande et recevoir notre réponse.</span></div></article>
              <article><CalendarDays /><div><strong>Prendre rendez-vous</strong><span>Pour choisir directement un créneau, utilisez le calendrier de réservation.</span></div></article>
            </div>
            <div className="contact-socials"><span>Suivre {siteSettings.societyName}</span><SocialButtons settings={siteSettings} /></div>
            <div className="contact-direct-note"><MessageCircle /><span>Pour une inspiration, vous pouvez aussi nous écrire sur les réseaux sociaux.</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}
